import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IDataContext, IMouseEventHandler } from '../../../core/component/list/component.interface';
import { EmailDeliveryStatus } from '../../../message/model/const/enums';
import { InvoiceDeliveryMethod, InvoiceDeliveryMethodToString } from '../../model/const/enum';
import { Invoice } from '../../model/invoice';
import { InvoiceDelivery } from '../../model/invoice-delivery';

@Component({
    selector: 'app-invoice-delivery',
    templateUrl: './invoice-delivery.component.html',
    styleUrls: ['./invoice-delivery.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoiceDeliveryComponent implements OnInit, IDataContext, IMouseEventHandler {
  constructor() {}

  dataContext: Invoice | InvoiceDeliveryMethod;

  private get invoiceLike(): Invoice | null {
    return this.dataContext && typeof this.dataContext === 'object' && 'deliveryMethod' in this.dataContext ? (this.dataContext as Invoice) : null;
  }

  private get invoice(): Invoice | null {
    return this.invoiceLike;
  }

  private get deliveryMethod(): InvoiceDeliveryMethod | null {
    if (typeof this.dataContext === 'number') {
      return this.dataContext as InvoiceDeliveryMethod;
    }

    return this.invoice?.deliveryMethod ?? null;
  }

  get isExternalAccountsReceivable(): boolean {
    return this.deliveryMethod === InvoiceDeliveryMethod.ExternalAccountsReceivable;
  }

  private _latestDelivery: InvoiceDelivery = undefined;
  get latestDelivery(): InvoiceDelivery {
    if (this._latestDelivery === undefined) {
      if (!this.invoice || this.invoice.deliveries.length === 0) {
        this._latestDelivery = null;
      } else {
        this.invoice.deliveries.sort((a, b) => (a.createdDate > b.createdDate ? -1 : 1));
        this._latestDelivery = this.invoice.deliveries[0];
      }
    }
    return this._latestDelivery;
  }

  get iconClass(): any {
    if (this.deliveryMethod !== null) {
      return {
        'email-i': this.deliveryMethod === InvoiceDeliveryMethod.EmailWithoutPDF,
        'emailpdf-i': this.deliveryMethod === InvoiceDeliveryMethod.EmailWithPDF,
        'mail-i': this.deliveryMethod === InvoiceDeliveryMethod.Mail,
        'print-i': this.deliveryMethod === InvoiceDeliveryMethod.Manual,
        'avy-i': this.deliveryMethod === InvoiceDeliveryMethod.Avy,
        'kivra-i': this.deliveryMethod === InvoiceDeliveryMethod.Kivra,
        'einvoicecompany-i': this.deliveryMethod === InvoiceDeliveryMethod.EInvoiceB2B,
        'einvoice-i': this.deliveryMethod === InvoiceDeliveryMethod.EInvoiceB2C,
      };
    }
  }

  showText: boolean;
  get deliveryText(): string {
    if (this.invoice?.invoiceDeliveryMethodText) {
      return this.invoice.invoiceDeliveryMethodText;
    }

    return this.deliveryMethod !== null ? InvoiceDeliveryMethodToString(this.deliveryMethod) : '';
  }
  get textClass(): any {
    if (this.deliveryMethod !== null) {
      return {
        'view-text': this.deliveryMethod === InvoiceDeliveryMethod.EmailWithPDF || this.deliveryMethod === InvoiceDeliveryMethod.EmailWithoutPDF,
        'view-text1': this.deliveryMethod === InvoiceDeliveryMethod.Mail,
        'view-text2': this.deliveryMethod === InvoiceDeliveryMethod.Manual,
        'view-text3':
          this.deliveryMethod === InvoiceDeliveryMethod.EInvoiceB2B || this.deliveryMethod === InvoiceDeliveryMethod.EInvoiceB2C,
      };
    }
  }

  mouseEnter() {
    this.showText = true;
  }

  mouseLeave() {
    this.showText = false;
  }

  ngOnInit() {}
}
